import React, { useState } from 'react';
import { ILegalRequirementTemplate } from '../Interfaces/ILegalRequirementTemplate';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
} from '@mui/material';
import { CopyAll } from '@mui/icons-material';
import { DataGrid, GridRowSelectionModel, deDE } from '@mui/x-data-grid';
import { columnsLegalRequirementTemplate } from './LegalTransactionTypeOverview';
import {
  useGetLegalRequirementTemplates,
  useGetLegalRequirementTemplateFullObjectsByIds,
} from '../hooks/reactQuerys/LegalRequirementQueries';

interface IProps {
  idLegalPhaseTemplate: number;
  startId: number;
  setArray: Function;
}

export const LegalPhaseCopyRequirement: React.FC<IProps> = ({
  idLegalPhaseTemplate,
  startId,
  setArray,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [
    legalRequirementTemplateChoosenIds,
    setLegalRequirementTemplateChoosenIds,
  ] = useState<number[]>([]);
  //
  const { legalRequirementTemplates } = useGetLegalRequirementTemplates();
  //
  const {
    LegalRequirementTemplateFullObjectsByIds,
    isLoadingLegalRequirementTemplateFullObjectsByIds,
  } = useGetLegalRequirementTemplateFullObjectsByIds(
    legalRequirementTemplateChoosenIds
  );
  //
  const handleSearch = () => {
    if (!legalRequirementTemplates || legalRequirementTemplates.length === 0) {
      return [];
    } else if (searchTerm === '') {
      return legalRequirementTemplates.filter(x => x.isTemplate);
    } else {
      return legalRequirementTemplates.filter(
        x =>
          x.isTemplate &&
          (String(x.LegalRequirementTemplate || '')
            .toLocaleLowerCase()
            .includes(searchTerm.toLocaleLowerCase()) ||
            String(x.idLegalRequirementTemplate || '')
              .toLocaleLowerCase()
              .includes(searchTerm.toLocaleLowerCase()))
      );
    }
  };

  const filteredRows = handleSearch();

  const handleRowSelectionChange = (newSelection: GridRowSelectionModel) => {
    const updatedSelection = Array.from(
      new Set([...(newSelection as number[])])
    );
    const updatedSelectionAsString = Array.from(
      new Set([...(newSelection as string[])])
    );
    setLegalRequirementTemplateChoosenIds(updatedSelection);
    setSelectedRow(updatedSelectionAsString);
  };

  const handleAdd = () => {
    if (selectedRow.length > 0 && legalRequirementTemplates) {
      const returnArray: ILegalRequirementTemplate[] = [];
      let tmpId = startId - 1;

      if (tmpId > 0) {
        tmpId = -1;
      }

      if (LegalRequirementTemplateFullObjectsByIds) {
        LegalRequirementTemplateFullObjectsByIds.forEach((fullObject, idx) => {
          if (fullObject !== undefined) {
            const tmpObject = {
              ...fullObject,
              idLegalPhaseTemplate: idLegalPhaseTemplate,
              idLegalRequirementTemplate: tmpId - idx,
              currentProcessingTime: fullObject.idLegalRequirementTemplate,
              isTemplate: false,
            };
            returnArray.push(tmpObject);
          }
        });
        setArray([...returnArray]);
      }
    }
    setIsOpen(false);
  };

  if (legalRequirementTemplates === undefined) {
    return (
      <IconButton sx={{ float: 'right' }} size='small' onClick={() => {}}>
        <CircularProgress size={24}></CircularProgress>
      </IconButton>
    );
  }

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        maxWidth='lg'
        fullWidth
      >
        <DialogTitle
          variant='h5'
          sx={{
            borderBottom: '1px solid #ccc', // Optional: Eine Trennlinie für visuelle Klarheit
          }}
        >
          Maßnahmen kopieren
          {isLoadingLegalRequirementTemplateFullObjectsByIds && (
            <CircularProgress size={24} sx={{ ml: 2, float: 'right', mr: 2 }} />
          )}
        </DialogTitle>
        <DialogContent>
          <TextField
            sx={{ mt: 2, mb: 2 }}
            label='Suche'
            fullWidth
            value={searchTerm}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setSearchTerm(event.target.value)
            }
          />

          <DataGrid
            localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
            rows={filteredRows}
            columns={columnsLegalRequirementTemplate}
            getRowId={row => String(row.idLegalRequirementTemplate)} // Sicherstellen, dass IDs als Strings behandelt werden
            checkboxSelection
            autoHeight
            rowSelectionModel={selectedRow} // Verwende rowSelectionModel statt selectionModel
            onRowSelectionModelChange={handleRowSelectionChange}
          />
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={() => setIsOpen(false)}>
            Schließen
          </Button>
          <Button
            variant='contained'
            onClick={handleAdd}
            disabled={
              isLoadingLegalRequirementTemplateFullObjectsByIds ||
              legalRequirementTemplateChoosenIds.length === 0
            }
          >
            Hinzufügen
          </Button>
        </DialogActions>
      </Dialog>

      <Tooltip title='Neue Maßnahme aus Katalog hinzufügen'>
        <IconButton
          sx={{ float: 'right' }}
          size='small'
          onClick={() => {
            setSelectedRow([]);
            setIsOpen(true);
          }}
        >
          <CopyAll />
        </IconButton>
      </Tooltip>
    </>
  );
};
